import { styled } from "@mui/material"

export const Separator = styled("hr")(({ theme }) => ({
	width: "100%",
	marginTop: "1em",
	marginBottom: "1em",
	border: "none",
	borderTop: `1px solid ${theme.palette.divider}`
}))
